export default "__VITE_ASSET__uArZki_l__"